<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header text-center d-block">
      <h4 class="text-primary">{{ data?.value?.request ?? data?.value?.name }}</h4>
      <!-- <button type="button" (click)="close()"  class="close-modal">
          <i class="icon-cross-small"></i>
        </button> -->
    </div>
    <div class="modal-body">
      <form [formGroup]="form" class="form-row">


        <ng-container *ngFor="let field of dynamicFiledList; index as i;">
          <div [ngClass]="field.type == 'file' ? 'col-12': field.type == 'checkbox' ? 'col-12':'col-12'">
            <!-- <label style="color: #808080;" *ngIf="field.type=='file'">{{ field.label }} <span -->
            <label style="color: #808080;"
              *ngIf="field.label&&(field.type=='file' || field.type=='checkbox' || field.type=='radio')">{{ field.label
              }} <span *ngIf="field.required === 'Y'"><b>*</b></span></label>
            <ng-container [ngSwitch]="field.type">
              <div *jrSwitchCases="['text','number']">
                <div class="form-group">
                  <div class="position-relative">
                    <input class="form-control floating" [name]="field.fieldname" [formControlName]="field.fieldname"
                      [placeholder]="field.placeholder" [type]="field.type" />
                    <label [for]="field.fieldname">{{field.label}}<span
                        *ngIf="field.required === 'Y'"><b>*</b></span></label>

                  </div>
                </div>
                <!-- <input class="form-control" [formControlName]="field.fieldname" [placeholder]="field.placeholder"
                    [type]="'text'" /> -->
                <!-- Show error message if invalid -->
                <!-- <div *ngIf="form.controls[field.fieldname]?.invalid && form.controls[field.fieldname]?.touched">
                        <small class="error" *ngIf="form.controls[field.fieldname]?.hasError('required')">
                          This field is required.
                        </small>
                        <small class="error" *ngIf="form.controls[field.fieldname]?.hasError('minlength')">
                          Minimum length is {{ field.minlength }} characters.
                        </small>
                        <small class="error" *ngIf="form.controls[field.fieldname]?.hasError('maxlength')">
                          Maximum length is {{ field.maxlength }} characters.
                        </small>
                      </div> -->
              </div>

              <!-- Select Dropdown -->
              <div *ngSwitchCase="'select'">
                <div class="form-group">
                  <div class="position-relative">
                    <select class="form-control w-100 floating" [formControlName]="field.fieldname">
                      <option selected disabled value="">Choose here</option>
                      <option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option>

                    </select>
                    <label [for]="field.fieldname">{{ field.label}}<span
                        *ngIf="field.required === 'Y'"><b>*</b></span></label>
                  </div>
                </div>
                <!-- <div class="form-group">
                    <select class="form-control w-100" [formControlName]="field.fieldname">
                      <option value="" selected disabled hidden>Choose here
                      </option>
                      <option *ngFor="let option of field.options" [value]="option.value">{{ option.name }}</option>
                    </select>
                  </div> -->

              </div>

              <!-- Radio Button -->
              <div *ngSwitchCase="'radio'">
                <div class="d-flex justify-content-start">

                  <div class="form-check" *ngFor="let option of field.options">
                    <input class="form-check-input" type="radio" [value]="option.value"
                      [formControlName]="field.fieldname" [id]="option.value">
                    <label class="form-check-label" [for]="option.value">{{ option.label }}</label>
                  </div>
                </div>

              </div>

              <!-- Checkbox -->
              <div *ngSwitchCase="'checkbox'">
                <div class="d-flex justify-content-start">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="{{field.fieldname}}" [name]="field.fieldname"
                      [formControlName]="field.fieldname">
                    <label class="form-check-label" for="{{field.fieldname}}">{{field.fieldname}}</label>
                  </div>

                </div>
                <input type="checkbox" [formControlName]="field.fieldname" />
              </div>

              <!-- Textarea -->
              <div *ngSwitchCase="'textarea'">
                <div class="position-relative">
                  <textarea class="form-control d-block w-100 " [name]="field.fieldname" rows="2" autocomplete="off"
                    [placeholder]="field.placeholder" [formControlName]="field.fieldname"></textarea>


                </div>
                <!-- <textarea class="form-control d-block w-100 " rows="2" autocomplete="off"
                    [placeholder]="field.placeholder" [formControlName]="field.fieldname"></textarea> -->

              </div>

              <!-- File Upload -->
              <div *ngSwitchCase='"file"'>
                <div class="fileBox">
                  <div class="uploadBox" *ngIf="!form.get(field.fieldname)?.value">
                    <div class="dragBox">
                      <img loading="lazy" src="assets/images/upload-file-icon.png" alt="" />
                      <input type="hidden" name="fileHidden" [formControlName]="field.fieldname" />
                      <input type="file" [name]="'fileData'" (change)="onFileSelect($event, field.fieldname)"
                        [accept]="field.accept_fileupload" />
                      <p class="d-block text-primary m-0">
                        Upload Document <br />
                        <span>File size must be less than 5MB</span>
                      </p>
                      <div *ngIf="form.get(field.fieldname)?.hasError('fileError')" class="text-danger">
                        {{ form.get(field.fieldname)?.getError('fileError') }}
                      </div>
                    </div>
                  </div>
                  <div class="previewBox" *ngIf="form.get(field.fieldname)?.value">
                    <div class="dragBox justify-content-between d-flex">
                      <div class="uploaded-file d-flex gap-2">
                        <app-fileimagepreview [fileType]="fileData?.name |GetFileExt | lowercase">
                        </app-fileimagepreview>

                        <span class="uploaded-file-wrap mb-2">
                          <small class="d-block">{{fileData?.name}}</small>
                          <small class="d-block">{{fileData?.size}}</small>
                        </span>
                      </div>
                      <div class="action-file">
                        <a [href]="form.get(field.fieldname)?.value" type="button" class="mx-1" target="_blank">
                          <i class="icon-eye text-primary"></i>
                        </a>
                        <a type="button" class="mx-1" (click)="clear(field.fieldname)">
                          <i class="icon-delete text-primary"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Default Case: if no matching type found -->
              <div *ngSwitchDefault>
                <span>Unsupported field type: {{ field.type }}</span>
              </div>

            </ng-container>
            <app-show-errors [ngStyle]="{'display': 'block'}" [ctrl]="form.get(field.fieldname)">
            </app-show-errors>
          </div>
        </ng-container>


      </form>
      <!-- <div [formGroup]="form">
              <label>{{ field.label }}</label>
  
              <div *ngIf="field.type === 'text'">
                <input [formControlName]="field.fieldname" [placeholder]="field.placeholder" />
              </div>
  
              <div *ngIf="field.type === 'select'">
                <select [formControlName]="field.fieldname">
                  <option *ngFor="let option of field.options" [value]="option">{{ option }}</option>
                </select>
              </div>
  
              <div *ngIf="field.type === 'radio'">
                <div *ngFor="let option of field.options">
                  <input type="radio" [formControlName]="field.fieldname" [value]="option">{{ option }}
                </div>
              </div>
  
              <div *ngIf="field.type === 'checkbox'">
                <input type="checkbox" [formControlName]="field.fieldname" />
              </div>
  
              <div *ngIf="field.type === 'file'">
                <input type="file" [formControlName]="field.fieldname" />
              </div>
  
              <div *ngIf="form.controls[field.fieldname]?.invalid && form.controls[field.fieldname]?.touched">
                <span class="error">This field is required!</span>
              </div>
            </div> -->

      <div class="_footer mt-auto justify-content-center text-center">
        <button type="button" class="btn btn-outline-primary mx-2" (click)="back()">
          Back
        </button>
        <button type="button" class="btn btn-primary mx-2" [disabled]="!form.valid" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>